import { Component, OnInit } from '@angular/core';
import { AgendaService } from 'app/services/agenda-personal/agenda.service';
import { Empresa } from 'app/entities/agenda';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { MatSnackBar, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-busqueda-grupo',
  templateUrl: './busqueda-grupo.component.html',
  styleUrls: ['./busqueda-grupo.component.scss']
})
export class BusquedaGrupoComponent implements OnInit {

  public empresas: Array<Empresa> = [];
  public selected_empresa: number;
  newForm: FormGroup;

  /**
   * Constructor
   * 
   * @param {AgendaService} _agenda 
   * @param {CarteraService} _cartera 
   * @param {MatSnackBar} _snackBar 
   * @param {MatDialogRef<BusquedaGrupoComponent>} _dialog 
   */
  constructor
  (
    private _agenda: AgendaService,
    private _cartera: CarteraService,
    private _snackBar: MatSnackBar,
    public _dialog: MatDialogRef<BusquedaGrupoComponent>
  )
  {
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._agenda.VerEmpresas().subscribe((data: Array<Empresa>) => this.empresas = data);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
  * Crea el formGroup
  */
  createForm(): FormGroup {
    return new FormGroup({
      documento: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ]),
      radicado: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ]),
      titulo: new FormControl()
    });
  }

  /**
   * Verifica si el grupo existe en la base de datos
   * @param {any} form
   */
  public buscarGrupo(form: any){
    // Validamos que empresa ha escogido para asignarle una base de datos //
    const Base_Datos: string = this.selected_empresa === 1 ? 'medisoft' : 'medisoftvet';

    this._cartera.VerInfoGrupo(form.radicado, form.documento, Base_Datos).subscribe((data: Array<any>) => {
      if(!data.length){
        this._snackBar.open('Usuario inexistente', '', {
          panelClass: ['warn-600'],
          duration: 2500
        });
        return;
      }else{
        this._dialog.close({form: form, base_datos: Base_Datos, empresa: this.selected_empresa});
      }
    });
  }

  /**
   * Cierra el modal y manda un objeto(form, base_datos, empresa)
   * @param {any} form
   */
  public addDiligencia(form: any){
    this._dialog.close({form: form, base_datos: null, empresa: this.selected_empresa});
  }

}
